import { Card, CardActions, CardContent, CardHeader, Chip, ListItemSecondaryAction } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import GetAppIcon from '@material-ui/icons/GetApp';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import { Skeleton } from "@material-ui/lab";
import CardBox from "components/CardBox";
import "moment/locale/tr";
import React from "react";
import IntlMessages from "util/IntlMessages";
import config from "../../../../config";
import { history } from "../../../../store";
import { getOtherAddWriterDetail, getUploadFileFullPathDownload } from "../../../../util/utilFunction";
import FileList from "../FileList";
export default function PubPreviewCard({  pub ,isLangInput=true ,fileList,visibility=true,previewRole,loading}) {
console.log("pub ",pub)
  const downloadFile = async (file) =>{
console.log("file ",file)
  //  let a = document.createElement('a');
  //           a.href = config.apiUrl + file.path + file.docId + file.ext;
  //           a.download = <IntlMessages id={"file.doctype."+file.docType} />;
  //           a.target="_blank";
  //           a.click();
          const fileName = config.docTypes[file.docType] + file.ext;
            getUploadFileFullPathDownload(file,fileName);
  };



  //console.log("pub ********************* ",pub)
 
 
  return (
    <Card maxWidth="lg" fullWidth>
      <CardHeader style={{ backgroundColor: "#f4f4f7" }}>
       {pub.type===1 ? <IntlMessages id="book" /> :  <IntlMessages id="article" /> } <IntlMessages id="button.preview" />
      </CardHeader>

      <CardContent style={{ backgroundColor: "#f4f4f7" }}>
          <div className="row">
          <CardBox
            styleName="col-md-6"
            heading={<IntlMessages id="pub.information" />}
          >
            <List dense={true}>
            <Divider light />

              <ListItem>
                <ListItemText  color="teal"
                  primary={<IntlMessages id="pub.title" values={{lang:pub.originalLang}}  />} primaryTypographyProps={{color:"secondary"}}
                  secondary={pub.title}
                />
              </ListItem>
              {
                
              pub.originalLang !== "Türkçe" && <ListItem>
              <ListItemText  color="teal"
                primary={<IntlMessages id="pub.turkishLangTitle" />} primaryTypographyProps={{color:"secondary"}}
                secondary={pub.turkishLangTitle}
              />
            </ListItem>
              }
              <Divider light />
              {visibility && <ListItem>
                <ListItemText
                  primary={<IntlMessages id="pub.owner" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ pub.owner}
                />
              </ListItem>}

              <Divider light />
              {visibility && <ListItem>
                <ListItemText
                  primary={<IntlMessages id="pub.writer" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ Array.isArray(pub.writers) ? (pub.writers.join(" , ") +" , "+ pub.other.join(" , ")) :   getOtherAddWriterDetail(pub)}
                />
              </ListItem>}
              <Divider light />
              <ListItem>
                <ListItemText
                  primary={<IntlMessages id="pub.keyword" values={{lang:pub.originalLang}}  />} primaryTypographyProps={{color:"secondary"}}
                  secondary={ 
                    Array.isArray(pub.keyword) 
                    ?
                    pub.keyword.map(keyWord=>
                      <Chip key={keyWord} disabled={!(visibility &&  previewRole !== "writer")} onClick={()=> visibility &&  previewRole !== "writer"  ? history.push("/yts/searchPub/"+keyWord) : null } color="primary" className="m-1" size="small" icon={<SpellcheckIcon />} label={keyWord} />
                      )
                    //pub.keyword.join(" , ") 
                    : pub.keyword.split(",").map(keyWord=>
                      <Chip key={keyWord} disabled={!(visibility &&  previewRole !== "writer")}  onClick={()=> visibility &&  previewRole !== "writer"  ? history.push("/yts/searchPub/"+keyWord) : null } color="primary" className="m-1" size="small" icon={<SpellcheckIcon />} label={keyWord} />
                      )}
 
                />
              </ListItem>
              <Divider light />
              <ListItem>
              <ListItemText
                  primary={<IntlMessages id="pub.type" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={pub.type===1 ? <IntlMessages id="book" /> : <IntlMessages id="article" />}
                />
              </ListItem>
              <Divider light />
              {
                pub.type===2 && [
                  <ListItem key="j112">
                  <ListItemText
                      primary={<IntlMessages id="pub.journalId" />} primaryTypographyProps={{color:"secondary"}}
                      secondary={<IntlMessages id={"journal."+pub.journalId} /> }
                    />

                    <ListItemSecondaryAction>
                    <img style={{width:200 , height:50}} alt={<IntlMessages id={"journal."+pub.journalId} />} src={require(`../../../../assets/images/journals/${pub.journalId}.jpg`)}>
                    </img>
                    </ListItemSecondaryAction>
                  
                  </ListItem>,
                  <Divider  key="j113" light />
                ]
              }
         

              <ListItem>
              <ListItemText
                  primary={<IntlMessages id="pub.institution" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={                    <IntlMessages id={"institution."+pub.institution} />        }
                />
              </ListItem>
              <Divider light />
              <ListItem>
              <ListItemText
                  primary={<IntlMessages id="pub.category" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={                    <IntlMessages id={"pub.categories."+pub.category} />        }
                />
              </ListItem>
              <Divider light />
              <ListItem>
              <ListItemText
                  primary={<IntlMessages id="pub.department" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={         pub.department}        
                />
              </ListItem>
              <Divider light />
              <ListItem>
                <ListItemText
                  primary={<IntlMessages id="pub.fieldOfStudy" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={ Array.isArray(pub.fieldOfStudy) ? pub.fieldOfStudy.join(" , ") : pub.fieldOfStudy}
                />
              </ListItem>
              <Divider light />

                <ListItem>
                <ListItemText
                  primary={<IntlMessages id="pub.isThesis" />}  primaryTypographyProps={{color:"secondary"}}
                  secondary={pub.isThesis === 1 ? <IntlMessages id="button.yes" /> : <IntlMessages id="button.no" /> }
                />
              </ListItem>
              <Divider light />
              {pub.isThesis === 1 &&
              <ListItem>
               
                <ListItemText primary={
                   // eslint-disable-next-line 
                <IntlMessages id="pub.thesisUrl" />}  primaryTypographyProps={{color:"secondary"}} secondary={<a href={pub.thesisUrl} target="_blank">{pub.thesisUrl}</a>
              }
                />
              </ListItem> }
              <Divider light />
              {pub.type === 1 &&
              <ListItem>
               
                <ListItemText primary={
                   // eslint-disable-next-line 
                <IntlMessages id="pub.ebookQuestion" />}  primaryTypographyProps={{color:"secondary"}} secondary={  pub.ebookQuestion === 1 ? <IntlMessages id="button.yes" /> : pub.ebookQuestion === 0 ?  <IntlMessages id="button.no" />   : "Seçilmedi"   }
                />
              </ListItem> }

            </List>
          </CardBox>
          <div className="col-md-6">
          <CardBox
            styleName="col-md-12"
            heading={<IntlMessages id="pub.publish.information" />}
          >
            <List dense={true}>
            <Divider light />

              <ListItem>
                <ListItemText  color="teal"
                  primary={<IntlMessages id="pub.publishedBefore" />} primaryTypographyProps={{color:"secondary"}}
                  secondary={pub.publishedBefore === 1 ? <IntlMessages id="button.yes" /> : <IntlMessages id="button.no" />}
                />
              </ListItem>
              <Divider light />
              {pub.publishedBefore === 1 && [
                    <ListItem>
                    <ListItemText
                      primary={<IntlMessages id="pub.publisher" />} primaryTypographyProps={{color:"secondary"}}
                      secondary={pub.publisher}
                    />
                  </ListItem>,
                  <Divider light />,
                  <ListItem>
                  <ListItemText
                    primary={<IntlMessages id="pub.publishYear" />} primaryTypographyProps={{color:"secondary"}}
                    secondary={pub.publishYear}
                  />
                </ListItem>,
                <Divider light />
                ]}

            
           
            </List>
          </CardBox>
        {
          (isLangInput || pub.langAbstract !=="") &&   <CardBox
          styleName="col-md-12"
          heading={<IntlMessages id="pub.lang" />}
        >
          <List dense="true">

            <Divider light />
            <ListItem>
              <ListItemText
                primary={<IntlMessages id="pub.lang" />} primaryTypographyProps={{color:"secondary"}}
                secondary={pub.lang}
              />
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText
                primary={<IntlMessages id="pub.langTitle" />} primaryTypographyProps={{color:"secondary"}}
                secondary={pub.langTitle}
              />
            </ListItem>
            <Divider light />
            <ListItem>
              <ListItemText
                primary={<IntlMessages id="pub.langKeyword" />} primaryTypographyProps={{color:"secondary"}}
                secondary={ Array.isArray(pub.langKeyword) ? pub.langKeyword.join(" , ") : pub.langKeyword}

              />
            </ListItem>
            <Divider light />
          

         
          </List>
        </CardBox>


}
   { 
   loading ? 
    <div>
       <Skeleton height={100} />
       <Skeleton height={100} />
       <Skeleton height={100} />
       <Skeleton height={100} />

    </div>
   :
   fileList.length>0 &&    
         <FileList fileList={fileList} 
                    title={<IntlMessages id="fileUpload.list.title"/>}
                    handleDeleteState={true}
                    handleDeleteIcon={<GetAppIcon/>}
                    handleDelete={downloadFile} 
                    styleName="col-md-12 alert-warning mb-2"
                    dense={true}
                    />
   }
        
        
          </div>
       </div>
     
          <div className="row">
          <CardBox
            styleName="col-md-12 col-12"
            heading={<IntlMessages id="pub.abstract"  values={{lang:pub.originalLang}}/>}
          >
        
              <span
                className="card-text"
                dangerouslySetInnerHTML={{ __html: pub.abstract }}
                
              />
                
              
           
          </CardBox>
          </div>



          {
                
                pub.originalLang !== "Türkçe" && 
                <div className="row">
                <CardBox
                  styleName="col-md-12 col-12"
                  heading={<IntlMessages id="pub.turkishLangAbstract" />}
                >
              
                    <span
                      className="card-text"
                      dangerouslySetInnerHTML={{ __html: pub.turkishLangAbstract }}
                      
                    />
                      
                    
                 
                </CardBox>
                </div>
                }

   { pub.langAbstract !== "" && 
      <div className="row">
      <CardBox
        styleName="col-md-12 col-12"
        heading={<IntlMessages id="pub.langAbstract" />}
      >
    
          <span
            className="card-text"
            dangerouslySetInnerHTML={{ __html: pub.langAbstract }}
            
          />
            
          
       
      </CardBox>
      </div>
   }
      </CardContent>
      <CardActions>
   
      </CardActions>
    </Card>
  );
}
